import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icon'
import FileFormatIcon from '../../../../features/components/Icons/FileFormatIcon'

import useCommonStyles from '../styles'

const PreviewThumbnail = memo(function WrappedPreviewThumbnail({
  filePreviewType,
  fileUrl,
  FileIcon,
  iconColor,
  fileFormat
}) {
  const { t } = useTranslation()
  const classes = useCommonStyles({ iconColor, hasIcon: !!FileIcon })

  if (!fileUrl && !FileIcon) {
    // representing the placeholder svg file icon
    // instead of broken image when previewUrl is not provided or failed to load
    return <FileFormatIcon className={classes.icon} fileFormat={fileFormat} />
  }

  return FileIcon ? (
    <Icon className={classes.icon}>
      <FileIcon />
    </Icon>
  ) : filePreviewType === 'image' ? (
    <img className={classes.preview} src={fileUrl} alt={t('filePreview')} />
  ) : (
    <video className={classes.preview} src={fileUrl} />
  )
})

PreviewThumbnail.propTypes = {
  filePreviewType: PropTypes.string,
  fileUrl: PropTypes.string,
  // icon from library or react component from imported file
  FileIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  iconColor: PropTypes.string,
  fileFormat: PropTypes.string
}

export default PreviewThumbnail
